<template>
    <div>
        <b-row v-for="(items, i) in rows" :key="'filter-row-' + i">
            <b-col cols="12" :md="getColSize(items, filter)" v-for="(filter, index) in items" :key="filter.name">
                <component :is="filter.type" v-model="items[index]" :disabled="disabled"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: ['value', 'disabled'],

        methods: {
            getColSize(items, filter) {
                if (filter.size) {
                    return filter.size;
                }
                let len = items.length;
                let max = 12;
                let diff = Math.ceil(max / len);

                return diff < 4 ? 4 : diff >= 6 ? 4 : diff;
            },
            groupBy: function (array, key) {
                const result = {};
                array.forEach(item => {
                    if (!result[item[key]]) {
                        result[item[key]] = []
                    }
                    result[item[key]].push(item)
                });
                return result
            }
        },

        computed: {
            rows() {
                return this.groupBy(this.value, 'row');
            }
        }
    }
</script>